<h2 mat-dialog-title class="my-5">{{('Create new Competitors' | translate) | async}}</h2>
<mat-dialog-content>
    <app-dynamic-form *ngIf="formGroup && inputForm" [formGroup]="formGroup" [inputForm]="inputForm"
        [appearanceForm]="'outline'" class="mt-10">
    </app-dynamic-form>
</mat-dialog-content>
<mat-dialog-actions *ngIf="showButton">
    <div class="w-full">
        <div class="flex flex-row justify-center items-center mt-8">
            <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSave()"
                class="w-1/3">{{utils.traslatei18n('Save')}}</button>
        </div>
    </div>
</mat-dialog-actions>